/*
 *  ┌───┐   ┌───┬───┬───┬───┐ ┌───┬───┬───┬───┐ ┌───┬───┬───┬───┐ ┌───┬───┬───┐
 *  │Esc│   │ F1│ F2│ F3│ F4│ │ F5│ F6│ F7│ F8│ │ F9│F10│F11│F12│ │P/S│S L│P/B│  ┌┐    ┌┐    ┌┐
 *  └───┘   └───┴───┴───┴───┘ └───┴───┴───┴───┘ └───┴───┴───┴───┘ └───┴───┴───┘  └┘    └┘    └┘
 *  ┌───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───────┐ ┌───┬───┬───┐ ┌───┬───┬───┬───┐
 *  │~ `│! 1│@ 2│# 3│$ 4│% 5│^ 6│& 7│* 8│( 9│) 0│_ -│+ =│ BacSp │ │Ins│Hom│PUp│ │N L│ / │ * │ - │
 *  ├───┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─────┤ ├───┼───┼───┤ ├───┼───┼───┼───┤
 *  │ Tab │ Q │ W │ E │ R │ T │ Y │ U │ I │ O │ P │{ [│} ]│ | \ │ │Del│End│PDn│ │ 7 │ 8 │ 9 │   │
 *  ├─────┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴─────┤ └───┴───┴───┘ ├───┼───┼───┤ + │
 *  │ Caps │ A │ S │ D │ F │ G │ H │ J │ K │ L │: ;│" '│ Enter  │               │ 4 │ 5 │ 6 │   │
 *  ├──────┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴────────┤     ┌───┐     ├───┼───┼───┼───┤
 *  │ Shift  │ Z │ X │ C │ V │ B │ N │ M │< ,│> .│? /│  Shift   │     │ ↑ │     │ 1 │ 2 │ 3 │   │
 *  ├─────┬──┴─┬─┴──┬┴───┴───┴───┴───┴───┴──┬┴───┼───┴┬────┬────┤ ┌───┼───┼───┐ ├───┴───┼───┤ E││
 *  │ Ctrl│    │Alt │         Space         │ Alt│    │    │Ctrl│ │ ← │ ↓ │ → │ │   0   │ . │←─┘│
 *  └─────┴────┴────┴───────────────────────┴────┴────┴────┴────┘ └───┴───┴───┘ └───────┴───┴───┘
 * 
 * @Author: xupeng ‘18309854921@163.com’
 * @Date: 2024-08-24 14:22:58
 * @LastEditors: xupeng ‘18309854921@163.com’
 * @LastEditTime: 2024-12-05 15:18:27
 * @FilePath: \admin\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import Vue from 'vue'
import Router from 'vue-router'

//引入nprogress
import NProgress from 'nprogress' // 进度条
import 'nprogress/nprogress.css' //这个样式必须引入

Vue.use(Router)
export const constantRoutes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/login/index')
  }, {
    path: '/index',
    component: () => import('../components/layout/index'),
    meta: { title: '类目管理', hidden: true, breadcrumb: true, breadcrumbNoClick: true, icon: 'el-icon-folder-opened'},
    children: [
      {
        path: '/index',
        meta: { title: '水卡管理', hidden: false, breadcrumb: true, id:'a'},
        component: () => import('../components/layout/children'),
        children: [
          {
            path: '/',
            name: 'index',
            meta: { title: '水卡管理', hidden: true, index: 1, isNeedKeepAlive: true},
            component: () => import('../views/index')
          },
          {
            path: '/addCard',
            name: 'addCard',
            meta: {title: '新增水卡', hidden: true, breadcrumb: false},
            component: () => import('../views/addCard')
          },
        ]
      },
      {
        path: '/cardType',
        meta: { title: '水卡规格管理', hidden: false, breadcrumb: true, id:'b'},
        component: () => import('../components/layout/children'),
        children: [
          {
            path: '/',
            name: 'cardType',
            meta: { title: '水卡规格管理', hidden: true, index: 1, isNeedKeepAlive: true},
            component: () => import('../views/cardType')
          }
        ]
      },
      {
        path: '/order',
        meta: { title: '订单管理', hidden: false, breadcrumb: true, id:'c'},
        component: () => import('../components/layout/children'),
        children: [
          {
            path: '/order',
            name: 'order',
            meta: { title: '订单管理', hidden: true, index: 1, isNeedKeepAlive: true},
            component: () => import('../views/order')
          },
        ]
      },
      {
        path: '/warehouse',
        meta: { title: '配送仓库管理', hidden: false, breadcrumb: true, id:'d'},
        component: () => import('../components/layout/children'),
        children: [
          {
            path: '/',
            name: 'warehouse',
            meta: { title: '配送仓库管理', hidden: true, index: 1, isNeedKeepAlive: true},
            component: () => import('../views/warehouse')
          },
          {
            path: '/warehouse/detail',
            name: 'warehouseDetail',
            meta: { title: '配送仓库管理', hidden: true, index: 1, isNeedKeepAlive: false},
            component: () => import('../views/warehouse/detail')
          }
        ]
      },
      {
        path: '/claim',
        meta: { title: '理赔管理', hidden: false, breadcrumb: true, id:'e'},
        component: () => import('../components/layout/children'),
        children: [
          {
            path: '/',
            name: 'claim',
            meta: { title: '理赔管理', hidden: true, index: 1, isNeedKeepAlive: true},
            component: () => import('../views/claim')
          }
        ]
      },
      {
        path: '/user',
        meta: { title: '用户管理', hidden: false, breadcrumb: true, id:'f'},
        component: () => import('../components/layout/children'),
        children: [
          {
            path: '/',
            name: 'user',
            meta: { title: '用户管理', hidden: true, index: 1, isNeedKeepAlive: true},
            component: () => import('../views/user')
          },
          // {
          //   path: '/user/add',
          //   name: 'userAdd',
          //   meta: { title: '用户管理', hidden: true, index: 1, isNeedKeepAlive: false},
          //   component: () => import('../views/user/add')
          // },
          // {
          //   path: '/user/edit',
          //   name: 'userEdit',
          //   meta: { title: '用户管理', hidden: true, index: 1, isNeedKeepAlive: false},
          //   component: () => import('../views/user/edit')
          // }
        ]
      },
      {
        path: '/faq',
        meta: { title: '常见问题管理', hidden: false, breadcrumb: true, id:'g'},
        component: () => import('../components/layout/children'),
        children: [
          {
            path: '/',
            name: 'faq',
            meta: { title: '常见问题管理', hidden: true, index: 1, isNeedKeepAlive: true},
            component: () => import('../views/faq')
          },
          {
            path: '/faq/add',
            name: 'faqAdd',
            meta: { title: '常见问题管理', hidden: true, index: 1, isNeedKeepAlive: false},
            component: () => import('../views/faq/add')
          },
          {
            path: '/faq/edit',
            name: 'faqEdit',
            meta: { title: '常见问题管理', hidden: true, index: 1, isNeedKeepAlive: false},
            component: () => import('../views/faq/edit')
          }
        ]
      },
      {
        path: '/jd',
        meta: { title: '系统属性管理', hidden: false, breadcrumb: true, id:'h'},
        component: () => import('../components/layout/children'),
        children: [
          {
            path: '/',
            name: 'jd',
            meta: { title: '系统属性管理', hidden: true, index: 1, isNeedKeepAlive: true},
            component: () => import('../views/jd')
          },
        ]
      },
      {
        path: '/administrators',
        meta: { title: '管理员管理', hidden: false, breadcrumb: true, id:'i'},
        component: () => import('../components/layout/children'),
        children: [
          {
            path: '/',
            name: 'administrators',
            meta: { title: '管理员管理', hidden: true, index: 1, isNeedKeepAlive: true},
            component: () => import('../views/administrators')
          },
        ]
      },
      {
        path: '/role',
        meta: { title: '角色设置', hidden: false, breadcrumb: true, id:'j'},
        component: () => import('../components/layout/children'),
        children: [
          {
            path: '/',
            name: 'role',
            meta: { title: '角色设置', hidden: true, index: 1, isNeedKeepAlive: true},
            component: () => import('../views/role')
          },
        ]
      },
    ]
  }
]

const createRouter = () => new Router({
  // mode: 'history',
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
  if (to.path === '/') {
    if (localStorage.getItem('access_token')) {
      next({ path: '/index' })
    } else {
      next()
    }
  } else {
    if (localStorage.getItem('access_token')) {
      next()
    } else {
      next({ path: '/' })
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})

const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
